import { render, staticRenderFns } from "./guide_record.vue?vue&type=template&id=10e43b56&scoped=true"
import script from "./guide_record.vue?vue&type=script&lang=ts"
export * from "./guide_record.vue?vue&type=script&lang=ts"
import style0 from "./guide_record.vue?vue&type=style&index=0&id=10e43b56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e43b56",
  null
  
)

export default component.exports